import template from "./component-loading.html";

function ViewModel(params) {
}

export default { viewModel: ViewModel, template: template };
